/** A stale chunk means this tab loaded its JS before the server's last deploy
 * replaced the build it came from — a plain client-side navigation (e.g.
 * "Begin assessment") then 404s fetching a chunk hash that no longer exists.
 * Resetting the error boundary alone cannot fix this: it re-renders the same
 * stale tree, which asks for the same missing chunk again. The fix is a hard
 * reload, which fetches the current HTML and the build that is actually
 * being served — see global-error.tsx, the only caller. */
export const isStaleChunkError = (error: Error): boolean =>
  /ChunkLoadError|Loading chunk .* failed|Failed to load chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
    `${error.name} ${error.message}`
  );
